import setCurrentPage from "src/Utils/setCurrentPage";

const LIST_DATA_BENEFITS_TEMPLATE = [
  {
    icon: "cycleInsideCircle",
    iconColor: "white",
    text: "Closed loop assurance",
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "clock",
    iconColor: "white",
    text: "Seamless integration\n with OSS/BSS systems",
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "graphDownArrowWithDollarSign",
    iconColor: "white",
    text: "Reduce OpEx cost",
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "computerWithScheme",
    iconColor: "white",
    text: `Improve operational\n KPIs by reducing mean\n time to repair by <b>60%</b>`,
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
];

export const DATA_BENEFITS_ISNA_3 = {
  title: "Self-heal",
  titleNumber: "3.",
  subtitle: "Low-code/No-code automation framework for \nnetwork self-healing.",
  listData: LIST_DATA_BENEFITS_TEMPLATE,
  styleListData: { marginTop: "80px" },
  next: {
    label: "NEXT",
    onClick: () => setCurrentPage("ENG_205"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ENG_203"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ENG/ISNA/ISNA_Introduction_04.png",
  showInfoButton: false,
  modalButton: "Self-heal demo",
  modalImages: [
    "ENG/ISNA/modal/ISNA_MODAL_selfHeal_1.png",
    "ENG/ISNA/modal/ISNA_MODAL_selfHeal_2.png",
    "ENG/ISNA/modal/ISNA_MODAL_selfHeal_3.png",
    "ENG/ISNA/modal/ISNA_MODAL_selfHeal_4.png",
  ],
};
